// Self-contained data for the Spotlight Events PH events concept website.
export const BUSINESS = {
  "slug": "spotlight-events-ph-concept",
  "media": {
    "hero": "/events/spotlight/04.jpg",
    "logo": "/events/spotlight/17.jpg",
    "gallery": [
      "/events/spotlight/01.jpg",
      "/events/spotlight/02.jpg",
      "/events/spotlight/03.jpg",
      "/events/spotlight/05.jpg",
      "/events/spotlight/06.jpg",
      "/events/spotlight/07.jpg",
      "/events/spotlight/08.jpg",
      "/events/spotlight/09.jpg",
      "/events/spotlight/10.jpg",
      "/events/spotlight/11.jpg",
      "/events/spotlight/12.jpg",
      "/events/spotlight/13.jpg",
      "/events/spotlight/14.jpg",
      "/events/spotlight/15.jpg",
      "/events/spotlight/16.jpg"
    ]
  },
  "name": "Spotlight Events PH",
  "shortName": "Spotlight",
  "kind": "planner",
  "layout": "hospitality",
  "location": "Talisay City, Cebu",
  "address": "B5 L23 Azienda Genova, Talisay City, Cebu 6045, Philippines",
  "eyebrow": "Hospitality-led planning in Cebu",
  "headline": "A steady hand behind every moving part.",
  "intro": "Wedding, corporate and social-event planning shaped by years of banquet and hotel operations experience.",
  "lead": "Aireen Mansueto",
  "leadRole": "Founder & event specialist",
  "story": "Aireen’s public professional profile traces her path through culinary administration, events and promotions, and banquet sales at Marco Polo Plaza Cebu before founding Spotlight in August 2014. That hospitality background brings a calm, operational character to the team’s work.",
  "services": [
    "Full planning and coordination",
    "Partial planning",
    "Day-of event management",
    "Weddings",
    "Corporate events and fairs",
    "Family days and fun runs",
    "Debuts, birthdays and anniversaries"
  ],
  "process": [
    "Understand the event, priorities and working budget",
    "Source and coordinate venue, food and suppliers",
    "Build schedules, logistics and rehearsals",
    "Lead execution so the client can stay present"
  ],
  "proof": [
    "Founded in August 2014",
    "Hospitality and banquet-operations background",
    "Wedding, corporate and large-event capability"
  ],
  "reviewSnapshot": "Public rating last checked in August 2026: 4.9/5 from 7 reviews. Confirm the current total on the live listing.",
  "reviews": [],
  "contact": {
    "phone": "+63 998 977 0276",
    "phoneHref": "+639989770276",
    "email": "spotlighteventsph@gmail.com",
    "facebook": "https://www.facebook.com/SpotlightEventsTeam/",
    "instagram": "https://www.instagram.com/spotlighteventsservices/"
  },
  "sources": [
    "https://www.freelancer.co.id/u/aireenm",
    "https://www.findglocal.com/PH/Talisay/568233713200050/Spotlight-Events-PH",
    "https://www.facebook.com/SpotlightEventsTeam/",
    "https://www.instagram.com/spotlighteventsservices/"
  ]
};
